import { useApiQuery, useApiMutation } from './useApi';
import api from '../api/client';

// =====================
// Notification Preferences
// =====================

export function useNotificationPreferences() {
  return useApiQuery('notification-preferences', '/notifications/preferences', {
    staleTime: 1000 * 60 * 5,
  });
}

export function useUpdateNotificationPreferences() {
  return useApiMutation(
    async (preferences) => {
      const response = await api.patch('/notifications/preferences', { preferences });
      return response.data;
    },
    { invalidateKeys: ['notification-preferences'] }
  );
}

// =====================
// Push subscription
// =====================

export function useSubscribePush() {
  return useApiMutation(
    async (subscription) => {
      const response = await api.post('/notifications/subscribe', {
        endpoint: subscription.endpoint,
        keys: {
          p256dh: subscription.toJSON().keys.p256dh,
          auth: subscription.toJSON().keys.auth,
        },
      });
      return response.data;
    }
  );
}

export function useUnsubscribePush() {
  return useApiMutation(
    async (endpoint) => {
      const response = await api.delete('/notifications/subscribe', {
        data: { endpoint },
      });
      return response.data;
    }
  );
}
